
import { defineMessages } from 'react-intl';
const defaultMessages = defineMessages(
  {
    "billingInvoicesSelf": {
      "id": "billing_invoices.self",
      "defaultMessage": "Invoices"
    },
    "billingInvoicesDisputing": {
      "id": "billing_invoices.disputing",
      "defaultMessage": "in dispute"
    },
    "billingInvoicesDisputed": {
      "id": "billing_invoices.disputed",
      "defaultMessage": "disputed"
    },
    "billingInvoicesEmpty": {
      "id": "billing_invoices.empty",
      "defaultMessage": "No invoices."
    },
    "billingInvoicesFailed": {
      "id": "billing_invoices.failed",
      "defaultMessage": "overdue"
    },
    "billingInvoicesSubscriptionTitle": {
      "id": "billing_invoices.subscription_title",
      "defaultMessage": "Subscription Invoices"
    },
    "billingInvoicesTransactionTitle": {
      "id": "billing_invoices.transaction_title",
      "defaultMessage": "Transaction Fee Invoices"
    },
    "billingInvoicesNotPaid": {
      "id": "billing_invoices.not_paid",
      "defaultMessage": "not paid"
    },
    "billingInvoicesOverdue": {
      "id": "billing_invoices.overdue",
      "defaultMessage": "overdue"
    },
    "billingInvoicesPaid": {
      "id": "billing_invoices.paid",
      "defaultMessage": "paid"
    },
    "billingInvoicesPastDue": {
      "id": "billing_invoices.past_due",
      "defaultMessage": "past due"
    },
    "billingInvoicesPaymentDue": {
      "id": "billing_invoices.payment_due",
      "defaultMessage": "payment due"
    },
    "billingInvoicesPending": {
      "id": "billing_invoices.pending",
      "defaultMessage": "pending"
    },
    "billingInvoicesRefunded": {
      "id": "billing_invoices.refunded",
      "defaultMessage": "refunded"
    },
    "billingInvoicesUpcoming": {
      "id": "billing_invoices.upcoming",
      "defaultMessage": "upcoming"
    },
    "billingInvoicesVoided": {
      "id": "billing_invoices.voided",
      "defaultMessage": "voided"
    },
    "billingInvoicesShow": {
      "id": "billing_invoices.show",
      "defaultMessage": "View Invoice"
    },
    "billingInvoicesSearchInvoicesTitle": {
      "id": "billing_invoices.search_invoices_title",
      "defaultMessage": "Search invoices"
    },
    "billingInvoicesSubscription": {
      "id": "billing_invoices.subscription",
      "defaultMessage": "Subscription"
    },
    "billingInvoicesTaxes": {
      "id": "billing_invoices.taxes",
      "defaultMessage": "plus sales tax where applicable"
    },
    "billingInvoicesUncollectible": {
      "id": "billing_invoices.uncollectible",
      "defaultMessage": "uncollectible"
    },
    "billingInvoicesVoid": {
      "id": "billing_invoices.void",
      "defaultMessage": "voided"
    },
    "billingInvoicesLast7Days": {
      "id": "billing_invoices.7_days_ago",
      "defaultMessage": "Last 7 days"
    },
    "billingInvoicesLast30Days": {
      "id": "billing_invoices.30_days_ago",
      "defaultMessage": "Last 30 days"
    },
    "billingInvoicesLast90Days": {
      "id": "billing_invoices.90_days_ago",
      "defaultMessage": "Last 90 days"
    },
    "billingInvoicesLast6months": {
      "id": "billing_invoices.6_months_ago",
      "defaultMessage": "Last 6 months"
    },
    "billingInvoicesLast12months": {
      "id": "billing_invoices.12_months_ago",
      "defaultMessage": "Last 12 months"
    },
    "billingInvoicesCustom": {
      "id": "billing_invoices.custom",
      "defaultMessage": "Custom"
    },
  }
);
export default defaultMessages;
